import { useState, useEffect } from "react";

import { BsCheck2Square, BsSquare } from "react-icons/bs";

import TourFormat from "./Format";

export default function Payment({ price, changePrice, totalPrice }) {
  const priceSeperator = (x) => {
    let s = "";
    if (x > 0 && x.toString().length > 3) {
      x = x.toString();
      s = x.slice(-3);
      x = x.slice(0, -3);
      while (x.length > 3) {
        s = `${x.slice(-3)},${s}`;
        x = x.slice(0, -3);
      }
      s = `${x},${s}`;
    } else {
      s = x;
    }
    return s;
  };

  const changeState = (x) => {
    switch (x) {
      case 0:
        changePrice({
          ...price,
          basePrice: price.absolutePrice.price,
          absolutePrice: {
            ...price.absolutePrice,
            state: true,
          },
          reserveWithPrepayment: {
            ...price.reserveWithPrepayment,
            state: false,
          },
          reserveWithoutPrepayment: {
            state: false,
          },
        });
        break;
      case 1:
        changePrice({
          ...price,
          basePrice: price.reserveWithPrepayment.price,
          absolutePrice: {
            ...price.absolutePrice,
            state: false,
          },
          reserveWithPrepayment: {
            ...price.reserveWithPrepayment,
            state: true,
          },
          reserveWithoutPrepayment: {
            state: false,
          },
        });
        break;
      case 2:
        changePrice({
          ...price,
          basePrice: 0,
          absolutePrice: {
            ...price.absolutePrice,
            state: false,
          },
          reserveWithPrepayment: {
            ...price.reserveWithPrepayment,
            state: false,
          },
          reserveWithoutPrepayment: {
            state: true,
          },
        });
        break;
      default:
        return;
    }
  };

  const checkBox = (x) => {
    let style = { fontSize: "18px" };
    if (x) {
      return <BsCheck2Square style={style} />;
    } else {
      return <BsSquare style={style} />;
    }
  };

  return (
    <>
      <TourFormat title={"مبالغ قابل پرداخت آنلاین"}>
        <div className="the-payment">
          <h6 className="my-3" style={{ fontSize: "12px" }}>
            مبلغ قابل پرداخت برای ثبت نام تور: &nbsp;&nbsp;
            {priceSeperator(price.basePrice)}
            &nbsp; تومان
          </h6>
          <h6 className="mt-4" style={{ fontSize: "12px" }}>
            موارد قابل سفارش:
          </h6>
          <div className="d-flex flex-wrap">
            {price.otherPrices.map((value, index) => {
              return (
                <div
                  className="the-items selectable"
                  onClick={() =>
                    changePrice({
                      ...price,
                      otherPrices: price.otherPrices.map((val, ind) => {
                        if (index == ind) {
                          return {
                            ...val,
                            state: !value.state,
                          };
                        }
                        return val;
                      }),
                    })
                  }
                >
                  {checkBox(value.state)}
                  <span className="mx-2">{value.title} :</span>
                  {priceSeperator(value.price)}
                  &nbsp; تومان
                </div>
              );
            })}
          </div>
          <div className="row">
            <div
              className="the-items selectable the-btn1"
              style={{ color: "white" }}
              onClick={() => changeState(0)}
            >
              {checkBox(price.absolutePrice.state)}
              <span className="mx-2">خرید قطعی‌ </span>
            </div>
            {price.reservation ? (
              <>
                <div
                  className="the-items selectable the-btn2"
                  style={{ color: "white" }}
                  onClick={() => changeState(1)}
                >
                  {checkBox(price.reserveWithPrepayment.state)}
                  <span className="mx-2">رزرو آنلاین با پیش پرداخت‌ </span>
                </div>
                <div
                  className="the-items selectable the-btn3"
                  style={{ color: "white" }}
                  onClick={() => changeState(2)}
                >
                  {checkBox(price.reserveWithoutPrepayment.state)}
                  <span className="mx-2">رزرو آنلاین بدون پیش پرداخت </span>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          {price.reserveWithoutPrepayment.state ? (
            <div className="the-alert">
              رزرو شما از زمان پرداخت تا 2 روز معتبر خواهد بود.
            </div>
          ) : (
            ""
          )}
          <h4 className="the-items item-4">
            مبلغ نهایی:‌
            <span className="mx-2" style={{ color: "red" }}>
              {priceSeperator(totalPrice)} &nbsp; تومان
            </span>
          </h4>
        </div>
      </TourFormat>
    </>
  );
}
